var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "checkmark-icon",
    attrs: {
      "aria-label": "Checkmark"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "checkmark"
  }, [_c('img', {
    attrs: {
      "src": _vm.doneButton,
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "checkmark-text"
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }